import axios from 'axios';
import { Message } from 'element-ui';

const TOKEN_KEY = 'admin_access_token';

const handleUnauthorized = (message) => {
  localStorage.removeItem(TOKEN_KEY);
  Message.error(message || '登录已过期，请重新登录');
  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
};

const service = axios.create({
  baseURL: '/api/v1',
  timeout: 10000
});

service.interceptors.request.use(
  config => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code !== 200) {
      Message.error(res.message || 'Error');
      if (res.code === 401) {
        handleUnauthorized(res.message);
      }
      return Promise.reject(new Error(res.message || 'Error'));
    }
    return res.data;
  },
  error => {
    const statusCode = error && error.response ? error.response.status : 0;
    const payload = error && error.response ? error.response.data : null;
    if (statusCode === 401 || (payload && payload.code === 401)) {
      handleUnauthorized((payload && payload.message) || error.message);
      return Promise.reject(error);
    }
    Message.error((payload && payload.message) || error.message || 'Request Error');
    return Promise.reject(error);
  }
);

export default {
  setToken(token) {
    if (token) localStorage.setItem(TOKEN_KEY, token);
  },
  clearToken() {
    localStorage.removeItem(TOKEN_KEY);
  },
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },
  login(data) {
    return service.post('/admin/login', data);
  },
  getDashboardStats() {
    return service.get('/admin/dashboard/stats');
  },
  getStudents(params) {
    return service.get('/admin/students', { params });
  },
  // Level Management
  getLevels() {
    return service.get('/admin/levels');
  },
  createLevel(data) {
    return service.post('/admin/levels', data);
  },
  updateLevel(id, data) {
    return service.put(`/admin/levels/${id}`, data);
  },
  deleteLevel(id) {
    return service.delete(`/admin/levels/${id}`);
  },
  getQuestionRecords(params) {
    return service.get('/admin/question_records', { params });
  },
  getWrongQuestions(params) {
    return service.get('/admin/wrong_questions', { params });
  },
  getQuestionAttempts(params) {
    return service.get('/admin/question_attempts', { params });
  },
  getPlatformVisits(params) {
    return service.get('/admin/platform/visits', { params });
  }
};
